module.exports = __webpack_public_path__ + "assets/img/crayon12.dfbcc828.png";